import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PricingViewComponent } from './views/pricing-view/pricing-view.component';
import { OtpComponent } from './views/otp/otp.component';
import { FilterDropdownComponent } from './views/filter-dropdown/filter-dropdown.component';
import { HeaderComponent } from './views/header/header.component';
import { SideNavComponent } from './views/side-nav/side-nav.component';
import { FooterComponent } from './views/footer/footer.component';
import { CitySelectComponent } from './views/city-select/city-select.component';
import { CarInfoComponent } from '../main/shared-views/car-info/car-info.component';
import { NoHassleComponent } from './views/no-hassle/no-hassle.component';
import { DisableBodyScrollDirective } from './directive/disable-body-scroll.directive';
import { ProcessComponent } from './views/process/process.component';
import { CityContentComponent } from './views/city-content/city-content.component';
import { SearchMobileComponent } from './views/search-mobile/search-mobile.component';
import { AutoFocusDirective } from './directive/auto-focus.directive';
import { SearchResultComponent } from './views/search-result/search-result.component';
import { TabButtonComponent } from './views/tab-button/tab-button.component';
import { ShortlistButtonComponent } from './views/shortlist-button/shortlist-button.component';
import { PrettyTextPipe } from 'src/app/core/pipe/pretty-text.pipe';
import { PrettyPricePipe } from 'src/app/core/pipe/pretty-price.pipe';
import { LogoComponent } from './views/logo/logo.component';
import { VehicleCardLoaderComponent } from './views/vehicle-card-loader/vehicle-card-loader.component';
import { LoadingPlaceholderComponent } from './views/loading-placeholder/loading-placeholder.component';
import { ItemLoaderComponent } from './views/item-loader/item-loader.component';
import { CarOverviewComponent } from './views/car-overview/car-overview.component';
import { P3ButtonComponent } from './views/p3-button/p3-button.component';
import { PriceCalculatorComponent } from '../main/shared-views/price-calculator/price-calculator.component';
import { ArraySortPipe } from 'src/app/core/pipe/sort.pipe';
import { CarCardComponent } from '../main/shared-views/car-card/car-card.component';
import { ImageCarouselComponent } from '../main/shared-views/image-carousel/image-carousel.component';
import { CarColorComponent } from './views/car-color/car-color.component';
import { CityPopupComponent } from './views/city-popup/city-popup.component';
import { KycProgressComponent } from './views/kyc-progress/kyc-progress.component';
import { BenefitsComponent } from './views/benefits/benefits.component';
import { ComparisonTableComponent } from './views/comparison-table/comparison-table.component';
import { CarShortlistContentComponent } from './views/car-shortlist-content/car-shortlist-content.component';
import { PrettyNumberPipe } from 'src/app/core/pipe/pretty-number.pipe';
import { StatsComponent } from './views/stats/stats.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { NotFoundComponent } from './layout/not-found/not-found.component';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { ExpertComponent } from '../main/home/views/expert/expert.component';
import { ImgResizePipe } from 'src/app/core/pipe/image-resize.pipe';
import { FaqViewComponent } from './views/faq-view/faq-view.component';
import { SubscriptionBenefitsComponent } from './views/subscription-benefits/subscription-benefits.component';
import { CarSubBenefitComponent } from './views/car-sub-benefit/car-sub-benefit.component';
import { MobileDashboardComparisonComponent } from './views/mobile-dashboard-comparison/mobile-dashboard-comparison.component';
import { MediaCoverageComponent } from './views/media-coverage/media-coverage.component';
import { CustomerTestimonialComponent } from './views/customer-testimonial/customer-testimonial.component';
import { BrandPartnersComponent } from './views/brand-partners/brand-partners.component';
import { EmployeeEmployerBenefitsComponent } from './views/employee-employer-benefits/employee-employer-benefits.component';
import { CorporateOnboardingComponent } from './views/corporate-onboarding/corporate-onboarding.component';
import { BusinessPlanComponent } from './views/business-plan/business-plan.component';
import { CorporateFaqsComponent } from './views/corporate-faqs/corporate-faqs.component';
import { OperationalCapabilityInIndiaComponent } from './views/operational-capability-in-india/operational-capability-in-india.component';
import { RouterModule } from '@angular/router';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { InvestFaqComponent } from './views/invest-faq/invest-faq.component';

const MODULES = [
  CommonModule,
  FontAwesomeModule,
  FormsModule,
  ReactiveFormsModule,
  NgxSliderModule,
  CarouselModule,
  AccordionModule,
  RouterModule,
];

const COMPONENTS = [
  CarCardComponent,
  ImageCarouselComponent,
  PricingViewComponent,
  OtpComponent,
  FilterDropdownComponent,
  HeaderComponent,
  SideNavComponent,
  FooterComponent,
  CitySelectComponent,
  CarInfoComponent,
  NoHassleComponent,
  ProcessComponent,
  CityContentComponent,
  SearchMobileComponent,
  SearchResultComponent,
  TabButtonComponent,
  ShortlistButtonComponent,
  LogoComponent,
  VehicleCardLoaderComponent,
  LoadingPlaceholderComponent,
  ItemLoaderComponent,
  CarOverviewComponent,
  P3ButtonComponent,
  PriceCalculatorComponent,
  CarColorComponent,
  CityPopupComponent,
  KycProgressComponent,
  BenefitsComponent,
  ComparisonTableComponent,
  CarShortlistContentComponent,
  StatsComponent,
  NotFoundComponent,
  ExpertComponent,
  FaqViewComponent,
  SubscriptionBenefitsComponent,
  CarSubBenefitComponent,
  MobileDashboardComparisonComponent,
  MediaCoverageComponent,
  CustomerTestimonialComponent,
  BrandPartnersComponent,
  EmployeeEmployerBenefitsComponent,
  CorporateOnboardingComponent,
  BusinessPlanComponent,
  CorporateFaqsComponent,
  OperationalCapabilityInIndiaComponent,
  InvestFaqComponent,
];

const DIRECTIVES = [
  DisableBodyScrollDirective,
  AutoFocusDirective,
];

const PIPES = [
  PrettyTextPipe,
  PrettyPricePipe,
  PrettyNumberPipe,
  ArraySortPipe,
  ImgResizePipe,
];

@NgModule({
  declarations: [
    ...COMPONENTS,
    ...DIRECTIVES,
    ...PIPES,
  ],
  imports: [
    ...MODULES,
  ],
  exports: [
    ...COMPONENTS,
    ...MODULES,
    ...DIRECTIVES,
    ...PIPES,
  ],
})
export class SharedModule { }
